import React, { useCallback } from "react";
import Card from "./Card";
import update from "immutability-helper";

interface CardInfo {
  id: number;
  enabled?: boolean;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  fieldElement?: any;
}

interface Props {
  cards: ReadonlyArray<CardInfo>;
  setCards: (cards: ReadonlyArray<CardInfo>) => void;
  WrappedComponent?: React.ComponentType;
  removeCardEnabled?: boolean;
  toggleAlignment?: boolean;
  disableAllFields?: boolean;
}

const CardList: React.FC<Props> = (props: Props): JSX.Element => {
  const { cards, setCards, WrappedComponent, removeCardEnabled, toggleAlignment, disableAllFields } = props;
  const moveCard = useCallback(
    (dragIndex: number, hoverIndex: number) => {
      const dragCard = cards[dragIndex];
      setCards(
        update(cards, {
          $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, dragCard],
          ],
        }),
      );
    },
    [cards],
  );

  const removeCard = (index: number): void => {
    setCards(
      update(cards, {
        $splice: [[index, 1]],
      }),
    );
  };

  return (
    <div className={"caprx-sortablelist"}>
      {cards.map((card, index) => (
        <Card
          key={card.id}
          index={index}
          info={card}
          moveCard={moveCard}
          WrappedComponent={card.fieldElement ? card.fieldElement : WrappedComponent}
          removeCard={removeCard}
          removeCardEnabled={removeCardEnabled}
          toggleAlignment={toggleAlignment}
          disableAllFields={disableAllFields}
        />
      ))}
    </div>
  );
};
export default CardList;
